// Created by: Imran Khan July 2026
export const FY_MONTHS = [
  "Apr", "May", "Jun", "Jul", "Aug", "Sep",
  "Oct", "Nov", "Dec", "Jan", "Feb", "Mar",
];

export function getCurrentFinancialYear() {
  const now = new Date();
  const month = now.getMonth() + 1;
  const startYear = month >= 4 ? now.getFullYear() : now.getFullYear() - 1;
  const endYear = startYear + 1;
  return {
    label: `${startYear}-${String(endYear).slice(-2)}`,
    value: `${startYear}-${String(endYear).slice(-2)}`,
    from: `${startYear}-04-01`,
    to: `${endYear}-03-31`,
  };
}

export function formatCurrency(amount, style = "full") {
  const num = Number(amount) || 0;
  if (style === "crore") {
    if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
    if (num >= 100000) return `₹${(num / 100000).toFixed(2)} L`;
    return `₹${num.toLocaleString("en-IN")}`;
  }
  return `₹${num.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
}

export function formatPercent(value) {
  const num = Number(value) || 0;
  return `${num > 0 ? "↑" : num < 0 ? "↓" : ""} ${Math.abs(num).toFixed(1)}%`;
}

export function formatDisplayDate(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function buildDashboardQueryParams({ from, to, salesExecutive }) {
  const params = new URLSearchParams({ from, to });
  if (salesExecutive) params.set("salesExecutive", salesExecutive);
  return params.toString();
}
